module.exports = __webpack_public_path__ + "media/images/front/bg_products_header_top-6d10e23e9942687d3e66e59dc85a3d58.jpg";